import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, IconButton, Typography, TextField, MenuItem, Stack, Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import EditProductForm from './EditProductForm';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { changeProductStatus } from '../../../../services/menuPage';

const ProductTable = ({ products, loading, error, refresh }) => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [filters, setFilters] = useState({ category: '', status: '' });
  const [deleteLoadingId, setDeleteLoadingId] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const uniqueCategories = [...new Set(products.map(p => p.category_name).filter(Boolean))];

  // المنتجات حسب التاب
  const activeProducts = products.filter(product => product.status === 1);
  const inactiveProducts = products.filter(product => product.status === 0);

  // فلترة حسب الفلاتر وشريط البحث
  const filteredProducts = (tabIndex === 0 ? activeProducts : inactiveProducts)
    .filter(product => {
      const matchCategory = filters.category ? product.category_name === filters.category : true;
      const matchSearch = searchTerm
        ? product.name.toLowerCase().includes(searchTerm.toLowerCase())
        : true;
      return matchCategory && matchSearch;
    });

  const handleDeleteProduct = async (product) => {
    if (!window.confirm(`هل أنت متأكد أنك تريد تغيير حالة المنتج "${product.name}"؟`)) return;
    setDeleteLoadingId(product.id);
    try {
      await changeProductStatus(product.id);
      setDeleteLoadingId(null);

      if (typeof refresh === "function") {
        await refresh(); // اعمل ريفرش للبيانات كلها من الباك إند
      }
    } catch (err) {
      setDeleteLoadingId(null);
      alert("❌ فشل في تغيير حالة المنتج.");
    }
  };

  const handleTabChange = (idx) => {
    setTabIndex(idx);
  };


  const columns = [
    {
      field: 'image',
      headerName: 'صورة',
      width: 100,
      renderCell: (params) => (
        <img
          src={`http://moumen01.restocash.app/${params.value}`}
          alt="product"
          width={60}
          height={60}
          style={{ objectFit: 'cover', borderRadius: 4 }}
        />
      ),
    },
    { field: 'name', headerName: 'الاسم', flex: 1 },
    { field: 'price', headerName: 'السعر', width: 100 },
    { field: 'product_cost', headerName: 'تكلفة', width: 100 }, // جديد
    { field: 'category_name', headerName: 'المجموعة', flex: 1 },
    {
      field: 'is_preparing',
      headerName: 'محتاج تحضير', // جديد
      width: 150,
      renderCell: (params) => (
        (params.value == 1 || params.value === '1') ? 'نعم' : 'لا'
      )
    },
    {
      field: 'preparing_time',
      headerName: 'زمن التحضير (د)', // جديد
      width: 150,
    },
    {
      field: 'status',
      headerName: 'الحالة',
      width: 120,
      renderCell: (params) => (
        params.value === 1 ? '✅ مفعل' : '🚫 غير مفعل'
      )
    },
    {
      field: 'actions',
      headerName: 'تعديل',
      width: 140,
      sortable: false,
      renderCell: (params) => (
        <Stack direction="row" spacing={1}>
          <IconButton onClick={() => setSelectedProduct(params.row)}>
            <EditIcon />
          </IconButton>
          <IconButton
            color="error"
            onClick={() => handleDeleteProduct(params.row)}
            disabled={deleteLoadingId === params.row.id}
          >
            <DeleteIcon />
          </IconButton>
        </Stack>
      )
    }
  ];

  return (
    <Box>
      {/* شريط البحث */}
      <Box sx={{ mb: 2 }}>
        <TextField
          label="بحث باسم المنتج"
          variant="outlined"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          fullWidth
        />
      </Box>
      {/* التابات */}
      <Stack direction="row" spacing={2} mb={2} alignItems="center">
        <TextField
          select
          label="فلترة حسب المجموعة"
          value={filters.category}
          onChange={(e) => setFilters({ ...filters, category: e.target.value })}
          sx={{ minWidth: 200 }}
        >
          <MenuItem value="">الكل</MenuItem>
          {uniqueCategories.map((cat, idx) => (
            <MenuItem key={idx} value={cat}>{cat}</MenuItem>
          ))}
        </TextField>
        {/* التاب لعرض المنتجات النشطة وغير النشطة */}
        <Stack direction="row" spacing={1}>
          <Button
            variant={tabIndex === 0 ? "contained" : "outlined"}
            color="primary"
            onClick={() => handleTabChange(0)}
          >
            المنتجات المفعلة
          </Button>
          <Button
            variant={tabIndex === 1 ? "contained" : "outlined"}
            color="error"
            onClick={() => handleTabChange(1)}
          >
            المنتجات غير المفعلة
          </Button>
        </Stack>
      </Stack>

      <div style={{ height: 600, width: '100%' }}>
        <DataGrid
          rows={filteredProducts}
          columns={columns}
          loading={loading}
          getRowId={(row) => row.id}
          disableRowSelectionOnClick
        />
      </div>

      <Dialog open={!!selectedProduct} onClose={() => setSelectedProduct(null)} maxWidth="sm" fullWidth>
        <DialogTitle>✏️ تعديل المنتج</DialogTitle>
        <DialogContent>
          {selectedProduct && (
            <EditProductForm
              initialData={selectedProduct}
              onSuccess={() => {
                setSelectedProduct(null);
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ProductTable;
